module.exports = __webpack_public_path__ + "static/media/ua.e2202cb6.svg";